<template>

    <div>

        <b-row>

            <b-col lg="12">

                <b-card>

                    <b-row>

                        <b-col sm="6" md="4" class="d-flex align-items-center justify-content-between my-1">
                            <date-picker
                                v-model="start_date"
                                placeholder="Start Date"
                                class="f-1"
                            /> &nbsp;to&nbsp;
                            <date-picker
                                v-model="end_date"
                                placeholder="End Date"
                                class="f-1"
                            />
                        </b-col>
                        <b-col sm="6" md="4" class="my-1" v-if=" caregiver == null ">

                            <user-role-search-dropdown type="provider" v-model=" caregiver_id "></user-role-search-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1" v-if=" client == null ">

                            <user-role-search-dropdown type="claimant" v-model=" client_id "></user-role-search-dropdown>
                        </b-col>
                        <b-col sm="6" md="4" class="my-1">

                            <b-form-select v-model=" subject ">

                                <option value="">All Subjects</option>
                                <option v-for=" item in subjects " :value=" item.subject " :key=" item.id ">{{ item.subject }}</option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="my-2">

                        <b-col class="d-flex justify-content-end align-items-center">

                            <b-button @click=" createScoped() " variant="success" v-if=" !isCarrierManager && scopeduser " class="mr-1">Create New</b-button>
                            <b-btn @click=" exportXls() " variant="success" class="my-1 mr-1" :disabled=" loading "><i class="fa fa-file-excel-o"></i> Export to Excel</b-btn>
                            <b-button @click=" loadTable() " variant="info" class="my-1" :disabled=" loading ">Generate Report</b-button>
                        </b-col>
                    </b-row>

                    <div class="table-responsive">

                        <b-table bordered striped hover show-empty
                            :items=" items "
                            :fields=" fields "
                            :current-page=" currentPage "
                            :per-page=" 0 "
                            :sort-by.sync=" sortBy "
                            :sort-desc.sync=" sortDesc "
                            :busy=" loading "
                        >
                            <template v-slot:cell(actions)="row">

                                <b-btn size="sm" :href=" `/${controller}/support-calls/${row.item.id}/edit` " target="_blank">View</b-btn>
                            </template>
                            <template v-slot:cell(created_at)="row">
                              <utc-time
                                  :time="row.item.created_at"
                                  timezone="America/Chicago"
                              />
                            </template>
                        </b-table>
                    </div>

                    <b-row>

                        <b-col lg="6" >

                            <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                        </b-col>
                        <b-col lg="6" class="text-right">

                            {{ paginationText }}
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import FormatsDates from "../../../mixins/FormatsDates";
    import PaginatedTable from "../../../mixins/PaginatedTable";
    import UsesRole from "../../../mixins/UsesRole";
    import ScopesToUser from "../../../mixins/ScopesToUser";

    export default {

        mixins: [ FormatsDates, PaginatedTable, UsesRole, ScopesToUser ],

        data() {

            return {

                subjects   : [],

                start_date : moment().subtract(1, 'week').format('MM/DD/YYYY'),
                end_date   : moment().format('MM/DD/YYYY'),
                subject    : ''
            }
        },

        computed: {

            fields(){


                const fields = [
                    {
                        key: 'callers',
                        label: 'Callers',
                        sortable: false,
                    },
                    {
                        key: 'subject',
                        label: 'Subject',
                        sortable: true,
                    },
                    {
                        key: 'created_at',
                        label: 'Call Date',
                        sortable: true,
                    },
                    { 
                        key: 'office_user_name',
                        label: 'Admin Name',
                        sortable: false,
                    },
                    {

                        key: 'actions',
                        class: 'hidden-print',
                    }
                ];

                return fields;
            },
            baseUrl(){ return `/${this.controller}/support-calls`; },
            appliedFilters(){ return `?start=${this.start_date}&end=${this.end_date}&client_id=${this.client_id}&caregiver_id=${this.caregiver_id}&subject_filter=${this.subject}`; }
        },

        methods: {

        },

        mounted(){

            axios.get( `/${this.controller}/support-call-subjects` )
                .then( res => {

                    this.subjects = res.data.subjects;
                })
        },
    }
</script>
